import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import {
  formatBenchmarkValue,
  getBarFillPercent,
  getBenchmarkStatusTier,
  getMedianMarkerPercent,
} from './utils'
import { getMetricIcon } from './metric-icons'
import {
  BenchmarkStatusChip,
  getBenchmarkBarFillColor,
} from './benchmark-chips'
import {
  BENCHMARK_USES_SAMPLE_METRICS,
  getCoachBenchmarksPath,
} from './constants'

const BenchmarkMetricRow = ({ metric, classes }) => {
  const statusTier = getBenchmarkStatusTier(metric)
  const coachDisplay = formatBenchmarkValue(metric.coachValue, metric.unit)
  const medianDisplay = formatBenchmarkValue(metric.medianValue, metric.unit)
  const fillPercent = getBarFillPercent(metric)
  const medianPercent = getMedianMarkerPercent(metric)
  const MetricIcon = getMetricIcon(metric.id)

  return (
    <Box
      component={RouterLink}
      to={getCoachBenchmarksPath(metric.id)}
      className={classes.metricRow}
    >
      <Box className={classes.metricLabelCell}>
        {MetricIcon ? (
          <Box className={classes.metricIconCircle} aria-hidden>
            <MetricIcon />
          </Box>
        ) : null}
        <Box className={classes.metricLabelText}>
          <Typography className={classes.metricLabel}>
            {metric.label}
          </Typography>
        </Box>
      </Box>

      <Box className={classes.metricVisual}>
        <Box className={classes.barTrack} aria-hidden>
          <Box
            className={classes.barFill}
            style={{
              width: `${fillPercent}%`,
              backgroundColor: getBenchmarkBarFillColor(statusTier),
            }}
          />
          <Box
            className={classes.medianMarker}
            style={{ left: `${medianPercent}%` }}
          />
        </Box>
      </Box>

      <Box className={classes.metricStats}>
        <Typography className={classes.metricValues}>
          {BENCHMARK_USES_SAMPLE_METRICS ? 'Sample' : 'You'}: {coachDisplay} |
          Median: {medianDisplay}
        </Typography>
        <BenchmarkStatusChip metric={metric} />
      </Box>
    </Box>
  )
}

BenchmarkMetricRow.propTypes = {
  metric: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    coachValue: PropTypes.number.isRequired,
    medianValue: PropTypes.number.isRequired,
    top10Value: PropTypes.number.isRequired,
    unit: PropTypes.oneOf(['percent', 'hours', 'currency']).isRequired,
    higherIsBetter: PropTypes.bool.isRequired,
  }).isRequired,
  classes: PropTypes.object.isRequired,
}

export default BenchmarkMetricRow
